import QUERY_PARAMS from './query-params';
import { urlAssignQuery } from 'growth-swiss-knife/utils';

export const run = () => {
    const selectors = [
        'a[href^="https://www.beekeeper.io/slf/v2"]',
        'a[href^="https://beekeeper.io/slf/v2"]',
    ].join(',');

    document.querySelectorAll(selectors).forEach(
        node => node.setAttribute('href', urlAssignQuery(node.getAttribute('href'), QUERY_PARAMS)),
    );
};
